import React from "react";
import { SvgIcon } from "@mui/material"
import logo from "../../shared/img/shopping-bag.svg"

export function ShoppingBagIcon() {
  return (
    <SvgIcon
      component={() => <img src={logo} alt="shopping-bag" />}
      inheritViewBox
    />
  )
}
